export function toggleMainNavigation() {

    const $window = $(window);
    const $html = $("html");
    const $menuItems = $(".main-menu > li");
    const $subMenus = $menuItems.find(".sub-menu");
    const $burgerBtn = $(".burger-btn");
    const $btnTemplate = `<button></button>`;

    initDropdowns();

    $burgerBtn.on("click", () => {
        if ($html.hasClass("show-nav")) {
            closeAllSubMenus();
        } else {
            $("html, body").animate({scrollTop: 0}, 300);
        }
        $html.toggleClass("show-nav");
    });

    //dropdowns
    $(document).on("click", ".main-menu > li > button", function () {
        if ($window.width() < 1200) {
            // toggle mobile dropdown
            if (!$(this).parent().hasClass("active")) {
                closeAllSubMenus();
                $(this).parent()
                    .addClass("active")
                    .find(".sub-menu").stop().slideDown();
            } else {
                $(this).parent()
                    .removeClass("active")
                    .find(".sub-menu").stop().slideUp();
            }
        } else {
            // toggle desktop touch dropdown
            if (!$(this).parent().hasClass("active")) {
                closeAllSubMenus();
                $(this).parent()
                    .addClass("active")
                    .find(".sub-menu").stop().fadeIn();
            } else {
                $(this).parent()
                    .removeClass("active")
                    .find(".sub-menu").stop().fadeOut();
            }
        }
    });

    $window.on("resize", function () {
        if ($(this).width() >= 1200) {
            closeAllSubMenus();
            $html.removeClass("show-nav");
        }
    });

    function initDropdowns() {
        $($btnTemplate).insertBefore(".sub-menu");
        $(".sub-menu").parent().addClass("has-sub-menu");
    }

    function closeAllSubMenus() {
        $subMenus.each((i, it) => {
            if ($(it).parent().hasClass("active")) {
                if ($window.width() < 1200) {
                    $(it)
                        .slideUp()
                        .parent().removeClass("active");
                } else {
                    $(it)
                        .fadeOut()
                        .parent().removeClass("active");
                }
            }
        })
    }
}




// WEBPACK FOOTER //
// ./assets/js/modules/toggle-main-navigation.js